module.exports = __webpack_public_path__ + "img/营业执照.7a09f68f.png";